import { create } from 'zustand';

import {
  AuthState,
  LoginFormData,
  LoginResponse,
} from '@/Login/types/authTypes';

import { api } from '../services/api';
import { extractErrorMessage } from '../utils/errorUtils';

export const useAuthStore = create<AuthState>((set, get) => ({
  isAuthenticated: false,
  isInitialized: false,
  token: null,

  login: async (loginData: LoginFormData) => {
    try {
      const response = await api.post<LoginResponse>(
        '/api/v1/auth/login',
        loginData,
      );

      if (response.success && response.data?.accessToken) {
        const token = response.data.accessToken;
        sessionStorage.setItem('token', token);
        set({
          isAuthenticated: true,
          token,
          isInitialized: true,
        });
        return { success: true };
      }

      return {
        success: false,
        message: response.message || 'Failed to login. Please try again.',
      };
    } catch (error) {
      const message = extractErrorMessage(error);
      return { success: false, message };
    }
  },

  logout: () => {
    sessionStorage.removeItem('token');
    set({
      isAuthenticated: false,
      token: null,
      isInitialized: true,
    });
  },

  // 🔥 핵심 수정 부분
  initialize: () => {
    try {
      // sessionStorage에서 토큰 확인
      const token = sessionStorage.getItem('token');

      if (token) {
        // 토큰이 있으면 인증된 상태로 설정
        set({
          isAuthenticated: true,
          token,
          isInitialized: true,
        });
      } else {
        // 토큰이 없으면 비인증 상태로 설정
        set({
          isAuthenticated: false,
          token: null,
          isInitialized: true,
        });
      }
    } catch (error) {
      // sessionStorage 접근 오류 시 비인증 상태로 설정
      console.error('Failed to initialize auth state:', error);
      set({
        isAuthenticated: false,
        token: null,
        isInitialized: true,
      });
    }
  },

  // 선택사항: 토큰 유효성 검증 함수 추가
  validateToken: async () => {
    const { token } = get();
    if (!token) {
      return false;
    }

    try {
      // 토큰 유효성 검증 API 호출 (예시)
      const response = await api.get('/api/v1/auth/validate');
      if (!response.success) {
        // 토큰이 유효하지 않으면 로그아웃 처리
        get().logout();
        return false;
      }
      return true;
    } catch (error) {
      // 토큰 검증 실패 시 로그아웃 처리
      get().logout();
      return false;
    }
  },
}));
